import displayTodoist from "./components/apps/todoist";
import displaySpotify from "./components/apps/spotify";
import displayVsCode from "./components/apps/vscode";
import { displayTerminal } from "./components/apps/terminal";
import { displaySettings } from "./components/apps/settings";
import { displayChrome } from "./components/apps/chrome";
import { displayTrash } from "./components/apps/trash";
import { displayGedit } from "./components/apps/gedit";
import { displayAboutAuthor } from "./components/apps/author";
import appContent from "../../config";
const { authorName } = appContent;
const apps = [
  {
    id: "chrome",
    title: "Google Chrome",
    icon: "./themes/Yaru/apps/chrome.png",
    disabled: false,
    favourite: true,
    desktop_shortcut: true,
    screen: displayChrome,
  },
  {
    id: "todo-ist",
    title: "Todoist",
    icon: "./themes/Yaru/apps/todoist.png",
    disabled: false,
    favourite: true,
    desktop_shortcut: false,
    screen: displayTodoist,
  },
  {
    id: "about-author",
    title: "About " + authorName,
    icon: "./themes/Yaru/system/user-home.png",
    disabled: false,
    favourite: true,
    desktop_shortcut: true,
    screen: displayAboutAuthor,
  },
  {
    id: "vscode",
    title: "Visual Studio Code",
    icon: "./themes/Yaru/apps/vscode.png",
    disabled: false,
    favourite: true,
    desktop_shortcut: false,
    screen: displayVsCode,
  },
  {
    id: "terminal",
    title: "Terminal",
    icon: "./themes/Yaru/apps/bash.png",
    disabled: false,
    favourite: true,
    desktop_shortcut: false,
    screen: displayTerminal,
  },
  {
    id: "spotify",
    title: "Spotify",
    icon: "./themes/Yaru/apps/spotify.png",
    disabled: false,
    favourite: true,
    desktop_shortcut: false,
    screen: displaySpotify, // India Top 50 Playlist 😅
  },
  {
    id: "settings",
    title: "Settings",
    icon: "./themes/Yaru/apps/gnome-control-center.png",
    disabled: false,
    favourite: true,
    desktop_shortcut: false,
    screen: displaySettings,
  },
  {
    id: "trash",
    title: "Trash",
    icon: "./themes/Yaru/system/user-trash-full.png",
    disabled: false,
    favourite: false,
    desktop_shortcut: true,
    screen: displayTrash,
  },
  {
    id: "gedit",
    title: "Send a Message",
    icon: "./themes/Yaru/apps/gedit.png",
    disabled: false,
    favourite: false,
    desktop_shortcut: true,
    screen: displayGedit,
  },
];

export default apps;
